// Phase 2.7 — Expense list section extracted from MonthlyAccounting.jsx.
// Auto-generated rows (from partner payment history) get an "auto" badge +
// disabled edit/delete because they're owned by the upstream record.

import { Section, Badge } from "@/components/Shared";
import { Pencil, Trash2 } from "lucide-react";
import { fmtINR, fmtPeriod } from "@/lib/api";

export default function ExpensesTab({
  monthExpenses,
  monthFilter,
  onEdit,
  onRemove,
}) {
  return (
    <Section
      title={monthFilter ? `Expense Details — ${fmtPeriod(monthFilter)}` : "All Expenses"}
      testid="ma-expenses"
    >
      <div className="overflow-x-auto"><table className="table-data w-full">
        <thead><tr>
          <th>Month</th>
          <th>Expense</th>
          <th>Reimb. to</th>
          <th className="text-right">Amount</th>
          <th>Comments</th>
          <th></th>
        </tr></thead>
        <tbody>
          {monthExpenses.map((e) => (
            <tr key={e.id} data-testid={`ma-exp-${e.id}`} className={e.auto ? "bg-[var(--accent)]/5" : ""}>
              <td className="num">{fmtPeriod(e.month)}</td>
              <td>
                {e.expense_label}
                {e.auto && <Badge tone="accent" className="ml-2">auto</Badge>}
              </td>
              <td><Badge tone={e.reimbursement_to === "BizAssist" ? "muted" : (e.reimbursement_to === "Partner" ? "accent" : "accent")}>{e.reimbursement_to}</Badge></td>
              <td className="text-right num">{fmtINR(e.amount, 0)}</td>
              <td className="text-[11px] text-[var(--muted)] truncate max-w-xs">{e.comments || "—"}</td>
              <td className="text-right">
                {e.auto ? (
                  <span className="text-[11px] text-[var(--muted)] italic" title="Edit via Partner Payment History">from partner history</span>
                ) : (
                  <>
                    <button onClick={() => onEdit(e)} className="p-1.5 hover:bg-[var(--surface-2)] rounded-sm"><Pencil size={13} /></button>
                    <button onClick={() => onRemove(e.id)} className="p-1.5 hover:bg-red-50 text-[var(--negative)] rounded-sm"><Trash2 size={13} /></button>
                  </>
                )}
              </td>
            </tr>
          ))}
          {!monthExpenses.length && <tr><td colSpan={6} className="text-center text-[var(--muted)] py-6">No expenses.</td></tr>}
        </tbody>
      </table></div>
    </Section>
  );
}
